webpackJsonp([1],{

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return firebaseConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebaseUiConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebaseui__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebaseui__);







var firebaseConfig = {
	apiKey: "AIzaSyBZ4B1yt_qpfhQdeOaj_ZF6EzS52H9YmZo",
	authDomain: "koonys-quizzes.firebaseapp.com",
	databaseURL: "https://koonys-quizzes.firebaseio.com"
};

var firebaseUiConfig = {
	callbacks: {
		signInSuccess: function signInSuccess(obj) {
			console.log("Erfolgreich eingeloggt.", obj);

			console.log('signInSuccess: ', obj.providerData[0]);

			__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + obj.uid).once('value').then(function (snap) {
				console.log('Hier..xx', snap.val());
				if (snap.val() == null) {
					console.log('User wird neu gespeichert.');
					__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + obj.uid).set(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj.providerData[0]));
				} else {
					console.log('User gab es schon.');
				}
			});

			console.log('Hier..');
			return false;
		}
	},
	signInFlow: "popup",
	credentialHelper: __WEBPACK_IMPORTED_MODULE_3_firebaseui___default.a.auth.CredentialHelper.NONE,
	signInOptions: [__WEBPACK_IMPORTED_MODULE_2_firebase__["auth"].GoogleAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"].PhoneAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"].FacebookAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"].TwitterAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"].EmailAuthProvider.PROVIDER_ID],
	tosUrl: "http://www.koonys.de"
};

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(711),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e4d27d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./one/loader.js": 234
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_EditQuizzes__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_EditQuizzes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__router_EditQuizzes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_Home__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__router_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_Quiz__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_Quiz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__router_Quiz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_meta__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_meta___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/asdf',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }, {
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_5__router_Home___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login___default.a
  }, {
    path: '/user/quizzes',
    name: 'Your Quizzes',
    component: __WEBPACK_IMPORTED_MODULE_4__router_EditQuizzes___default.a
  }, {
    path: '/:key(-[a-zA-Z0-9-_]{19})',
    name: 'QuizByKey',
    component: __WEBPACK_IMPORTED_MODULE_6__router_Quiz___default.a
  }, {
    path: '/:name',
    name: 'QuizByName',
    component: __WEBPACK_IMPORTED_MODULE_6__router_Quiz___default.a,
    title: 'Penis'
  }]
}));

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export firebaseApp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebaseui__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebaseui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebaseui_dist_firebaseui_css__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebaseui_dist_firebaseui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebaseui_dist_firebaseui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__database_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__questions_question_loader_js__ = __webpack_require__(235);






__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);









var firebaseApp = __WEBPACK_IMPORTED_MODULE_5_firebase__["initializeApp"](__WEBPACK_IMPORTED_MODULE_8__database_js__["b" /* firebaseConfig */]);
var auth = firebaseApp.auth();



auth.onAuthStateChanged(function (user) {

	if (user) {
		console.log(user.isAnonymous ? 'Gast.' : 'Eingeloggt.', user.uid);

		if (user.isAnonymous) {
			__WEBPACK_IMPORTED_MODULE_5_firebase__["database"]().ref('/users/' + user.uid).set({
				uid: user.uid,
				isAnonymous: true
			});
		}

		store.commit('setDB', firebaseApp);
		store.dispatch('user', user);
	} else {

		__WEBPACK_IMPORTED_MODULE_5_firebase__["auth"]().signInAnonymously().catch(function (error) {
			console.log('Error in signInAnonymously', error.code, error.message);
		});
	}
});

var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
	state: {
		user: { uid: null },
		ui: new __WEBPACK_IMPORTED_MODULE_6_firebaseui___default.a.auth.AuthUI(firebaseApp.auth()),
		db: null,
		fb: null,
		quizzes: [],
		publicQuizzes: [],
		quiz: null
	},
	mutations: {
		addFame: function addFame(state, obj) {
			state.quiz.hallOfFame.push(obj);
		},
		removeFame: function removeFame(state, obj) {
			state.quiz.hallOfFame = state.quiz.hallOfFame.filter(function (v) {
				return v.key != obj.fameKey;
			});
		},
		questionAnswered: function questionAnswered(state, questionKey) {
			state.db.ref('/sprints/' + state.user.uid + '/' + state.quiz.key + '/answered/' + questionKey).set(true);
			state.quiz.questions[questionKey].answered = true;
		},
		quizSolved: function quizSolved(state) {

			state.quiz.solved = true;
			state.db.ref('/sprints/' + state.user.uid + '/' + state.quiz.key + '/endTime').set(__WEBPACK_IMPORTED_MODULE_5_firebase__["database"].ServerValue.TIMESTAMP);

			state.db.ref('/sprints/' + state.user.uid + '/' + state.quiz.key).once('value', function (snapshot) {
				var sprint = snapshot.val();
				var duration = sprint.endTime - sprint.startTime;

				state.db.ref('hallOfFame/' + state.quiz.key).push({
					time: __WEBPACK_IMPORTED_MODULE_5_firebase__["database"].ServerValue.TIMESTAMP,
					duration: duration,
					username: state.user.displayName,
					userid: state.user.uid,
					photo: state.user.photoURL
				});

				state.quiz.endTime = sprint.endTime;
			});
		},
		setQuiz: function setQuiz(state, quiz) {
			state.quiz = quiz;
		},
		quizLoadFailed: function quizLoadFailed(state, key) {
			console.log('Failed loading Quiz with key: ', key);
			state.quiz = { failed: true };
		},
		updateStartTime: function updateStartTime(state, st) {
			state.quiz.startTime = st;
		},
		resetQuiz: function resetQuiz(state) {
			state.quiz = null;
		},
		updateQuizzes: function updateQuizzes(state, quizzes) {
			console.log(':::---::: store/updateQuizzes', quizzes);
			state.quizzes = quizzes;
		},
		setPublicQuizzes: function setPublicQuizzes(state, quizzes) {
			state.publicQuizzes = quizzes;
		},
		updateQuiz: function updateQuiz(state, obj) {
			console.log('updateQuiz', obj);

			state.db.ref('/sprints').once("value", function (snap) {

				for (var userSprintKey in snap.val()) {
					var userSprint = snap.val()[userSprintKey];

					for (var sprintKey in userSprint) {
						if (sprintKey == obj.key) {
							state.db.ref('/sprints/' + userSprintKey + '/' + sprintKey).remove();
						}
					}
				}
			});

			state.db.ref('/quizzes/' + obj.key).update(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ creator: state.user.displayName, uid: state.user.uid }, obj.quiz));

			state.db.ref('/users/' + state.user.uid + '/quizzes/' + obj.key).set(true);

			state.db.ref('/quizKeys/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_js__["b" /* toUrl */])(obj.quiz.name)).set(obj.key);

			if (obj.quiz.public) {
				state.db.ref('/publicQuizzes/' + obj.key).set(true);
			} else {
				state.db.ref('/publicQuizzes/' + obj.key).remove();
			}
		},
		removeQuiz: function removeQuiz(state, key) {

			state.db.ref('/quizzes/' + key).remove();

			state.db.ref('/users/' + state.user.uid + '/quizzes/' + key).remove();

			delete state.quizzes[key];
		},
		setUser: function setUser(state, user) {

			user.isAdmin = user.uid == 'Ag71aaRbPaPyvMTz3MkXvys9B7d2' || user.uid == 'NGxPZFky33c4CpIM7JXNfzYBVhv2';

			if (!user.isAdmin) {
				var console = {};
				console.log = function () {};
				console.warn = window.console.warn;
				console.error = window.console.error;
				console.info = window.console.info;
				window.console = console;
			}

			state.user = user;
		},
		resetUser: function resetUser(state) {
			state.user = { uid: null };
			store.state.quizzes = [];
		},
		setDB: function setDB(state, fb) {
			state.fb = fb;
			state.db = fb.database();
		},
		addQuiz: function addQuiz(state, quiz) {
			state.quizzes[quiz.key] = quiz;

			store.commit('updateQuiz', { key: quiz.key, quiz: quiz });
		}
	},
	actions: {
		deleteFame: function deleteFame(context, obj) {
			store.state.db.ref('/hallOfFame/' + obj.quizKey + '/' + obj.fameKey).remove();
		},
		startQuiz: function startQuiz(context, quizKey) {
			var userQuizRef = '/sprints/' + store.state.user.uid + '/' + quizKey;
			store.state.db.ref(userQuizRef).remove().then(function () {
				context.dispatch('loadQuiz', quizKey);
			});
		},
		loadQuizByName: function loadQuizByName(context, name) {
			store.state.db.ref('/quizKeys/' + name).once('value', function (snap) {
				console.log('loadQuizByName: ', name, snap.val(), snap.key);

				context.dispatch('loadQuiz', snap.val());
			});
		},
		loadQuiz: function loadQuiz(context, key) {
			console.log('loadQuiz', key);

			store.state.db.ref('hallOfFame/' + key).off();

			store.state.db.ref('/quizzes/' + key).once('value', function (snapshot) {

				var quiz = snapshot.val();
				console.log('Load Quiz: ', quiz);

				if (!quiz) {
					console.log('Loading adsf');

					context.commit('quizLoadFailed', key);
					return 'Loading failed.';
				}

				quiz.description = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_js__["c" /* video */])(quiz.description);

				var userQuizRef = '/sprints/' + store.state.user.uid + '/' + key;

				store.state.db.ref(userQuizRef).once('value', function (usersnap) {
					var userVariables = {};
					var sprint = usersnap.val();

					if (usersnap.val() == null) {
						quiz.variables && quiz.variables.forEach(function (v) {
							userVariables[v.name] = Math.floor(Math.random() * (parseInt(v.to) - parseInt(v.from) + 1) + parseInt(v.from));

							if (parseInt(v.from) < 0 && parseInt(v.to) > 0 && userVariables[v.name] == 0) {
								userVariables[v.name] = 1;
							}
						});

						store.state.db.ref(userQuizRef).set({
							startTime: __WEBPACK_IMPORTED_MODULE_5_firebase__["database"].ServerValue.TIMESTAMP,
							variables: userVariables
						}, function (v) {
							store.state.db.ref(userQuizRef).once('value', function (t) {
								context.commit('updateStartTime', t.val().startTime);
							});
						});
					} else {
						userVariables = usersnap.val() != null && usersnap.val().variables ? usersnap.val().variables : userVariables;

						if (usersnap.val().endTime) quiz.solved = true;
					}

					var _loop = function _loop() {
						var f = ':' + variableKey + ':';
						var t = userVariables[variableKey];

						quiz.questions.forEach(function (question, i, arri) {
							try {
								arri[i] = __WEBPACK_IMPORTED_MODULE_10__questions_question_loader_js__["a" /* default */].fill(f, t, question);
							} catch (e) {
								console.log('::::', e);
								arri[i] = question;
							}
						});
					};

					for (var variableKey in userVariables) {
						_loop();
					}

					quiz.questions && quiz.questions.forEach(function (question, i, arri) {

						try {
							arri[i] = __WEBPACK_IMPORTED_MODULE_10__questions_question_loader_js__["a" /* default */].evaluate(question, i);
						} catch (e) {
							arri[i] = question;
						}

						arri[i].answered = usersnap.val() != null && usersnap.val().answered != null && usersnap.val().answered[i] ? true : false;
					});

					var hallOfFame = [];
					store.state.db.ref('hallOfFame/' + key).on('child_added', function (f) {
						context.commit('addFame', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ key: f.key }, f.val()));
					});
					store.state.db.ref('hallOfFame/' + key).on('child_removed', function (f) {
						context.commit('removeFame', { fameKey: f.key, quizKey: key });
					});

					var startTime = usersnap.val() ? usersnap.val().startTime : 0;

					var endTime = usersnap.val() ? usersnap.val().endTime : 0;
					context.commit('setQuiz', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ key: snapshot.key }, quiz, { startTime: startTime, endTime: endTime, hallOfFame: hallOfFame, restart: false }));
				});
			}, function (e) {
				console.log('MIESER FEHLER', e);
			});
		},
		loadQuizzes: function loadQuizzes(context) {

			console.log('User: ', store.state.user.uid);

			store.state.quizzes.length == 0 && store.state.db.ref('/users/' + store.state.user.uid + '/quizzes').once('value', function (q) {
				console.log('Receive in loadQuizzes', q.val(), q.key);

				var Quizzes = {};
				var P = [];

				q.val() && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(q.val()).forEach(function (v) {
					P.push(store.state.db.ref('/quizzes/' + v).once('value', function (s) {
						Quizzes[v] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ key: v }, s.val());
					}));
				});

				__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(P).then(function () {
					context.commit('updateQuizzes', Quizzes);
				});
			});
		},
		loadPublicQuizzes: function loadPublicQuizzes(context) {

			var publicQuizzes = [];

			store.state.publicQuizzes.length == 0 && store.state.db.ref('/quizzes').once('value', function (snap) {
				snap.val() && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(snap.val()).forEach(function (v, i) {
					if (snap.val()[v].public) {
						publicQuizzes.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ key: v }, snap.val()[v]));
					}
				});

				publicQuizzes.sort(function (a, b) {
					return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
				});

				context.commit('setPublicQuizzes', publicQuizzes);
			});
		},
		user: function user(context, _user) {
			context.commit('setUser', _user);
		},
		logout: function logout(context) {

			auth.signOut().then(function () {
				context.commit('resetUser');
			}).catch(function (error) {});
		}
	}
});

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(285)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(710),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(225),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./one/One.Edit.vue": 209
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 220;

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./one/One.Edit.vue": 209,
	"./one/One.vue": 702
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    adClient: {
      type: String,
      required: true
    },
    adSlot: {
      type: String,
      required: true
    },
    adFormat: {
      type: String,
      required: false,
      default: 'auto'
    },
    adStyle: {
      type: String,
      required: false,
      default: 'display: block'
    }
  },
  mounted: function mounted() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {};
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Startseite',
      titleTemplate: 'Koonys Quizzes | %s',
      meta: [{ name: 'keywords', content: 'Aufgaben online, online testen, mathematik online, quiz online, online lernen, mathe online, lösungen online, aufgaben online testen' }]
    };
  },

  methods: {
    logout: function logout() {
      console.log('Logge out.', this.$router);

      this.$store.dispatch('logout');
      this.$router.push('/');
    }
  },
  computed: {
    user: function user() {

      return this.$store.state.user;
    }
  },
  beforeMount: function beforeMount() {
    console.log('before app mounted');
  },
  mounted: function mounted() {
    console.log('app mounted');
  }
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timer", function() { return timer; });

var timer = {
	template: '<span><i class="fa fa-clock-o fa-fw"></i>{{newTime}}</span>',
	props: ['time'],
	data: function data() {
		return {
			runInterval: null,
			newTime: this.convert(this.time)
		};
	},

	methods: {
		convert: function convert(time) {

			if (time == 0) {
				return 'Startet..';
			}

			var date = new Date();
			var diff = (date.getTime() - time) / 1000;
			if (diff < 0) diff = 0;

			var seconds = Math.round(diff % 60);
			seconds = seconds < 10 ? '0' + seconds : seconds;

			return Math.floor(diff / 60) + ':' + seconds;
		}
	},
	created: function created() {
		var _this = this;

		this.runInterval = setInterval(function () {
			_this.newTime = _this.convert(_this.time);
		}, 1000);
	},
	beforeDestroy: function beforeDestroy() {
		this.runInterval && clearInterval(this.runInterval);
	}
};



/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__database_js__ = __webpack_require__(126);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  computed: {
    logged: function logged() {
      console.log('logged', this.$store.state.user);

      if (!this.$store.state.user.isAnonymous) {
        this.$router.replace('/');
      }

      return false;
    }
  },
  mounted: function mounted() {
    this.$store.state.ui.start("#firebaseui-auth-container", __WEBPACK_IMPORTED_MODULE_0__database_js__["a" /* firebaseUiConfig */]);
  }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'question-one-edit',
	data: function data() {
		return {};
	},

	props: {
		question: {
			type: Object,
			required: true
		},
		questionKey: {
			type: Number,
			required: true
		}
	},
	updated: function updated() {},
	mounted: function mounted() {},

	methods: {
		addAlternative: function addAlternative() {
			console.log('addAlternative', this.question);
			var question = this.question;

			var newAlternative = { answer: '', message: '' };

			question.alternatives ? question.alternatives.push(newAlternative) : this.$set(this.question, 'alternatives', [newAlternative]);
		},
		removeAlternative: function removeAlternative(questionKey, alternativeKey) {
			this.question.alternatives.splice(alternativeKey, 1);
		}
	}
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'question-one',
	data: function data() {
		return {};
	},

	props: {
		question: {
			type: Object,
			required: true
		},
		questionKey: {
			type: Number,
			required: true
		}
	},
	updated: function updated() {},
	mounted: function mounted() {},

	methods: {
		submitAnswer: function submitAnswer() {
			var question = this.question;
			this.$store.state.user.isAdmin && console.log('Erwarte antwort: ', question.answer);

			if (question.answer == question.userAnswer.replace(/,/g, '.')) {
				this.$store.commit('questionAnswered', this.questionKey);
			} else {

				var tryType = 'danger';
				var message = 'Falsch.';

				question.alternatives && question.alternatives.forEach(function (alternative, i) {
					if (alternative.answer == question.userAnswer.replace(',', '.')) {
						tryType = 'warning';
						message = alternative.message;
					}
				});

				question.tryings.unshift({ answer: question.userAnswer, type: tryType, message: message });
			}
		}
	}
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autosize__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sortablejs__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sortablejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sortablejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_js__ = __webpack_require__(54);









/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			activeQuizKey: null,
			activeQuiz: {},
			newQuizName: '',
			questionTypes: __WEBPACK_IMPORTED_MODULE_4__helper_js__["a" /* questionTypes */],
			list: []
		};
	},

	methods: {
		preview: function preview(obj) {
			console.log('Obj:', obj);
			this.updateQuiz();

			window.open('/' + this.activeQuizKey, '_blank');
		},
		increase: function increase() {
			console.log('Davor: ', this.list);
			this.list.push({ bla: this.list.length });
			console.log('Danach: ', this.list);
		},
		addVariable: function addVariable() {
			this.activeQuiz.variables ? this.activeQuiz.variables.push({ name: String.fromCharCode(this.activeQuiz.variables.length + 97), from: 1, to: 10 }) : this.activeQuiz.variables = [{ name: 'a', from: 1, to: 10 }];
		},
		removeVariable: function removeVariable(variableKey) {
			this.activeQuiz.variables.splice(variableKey, 1);
		},
		addQuestion: function addQuestion(type) {
			console.log('Active Quiz: ', this.activeQuiz);

			var question = { type: type };

			this.activeQuiz.questions ? this.activeQuiz.questions.push(question) : this.activeQuiz.questions = [question];
		},
		removeQuestion: function removeQuestion(key) {
			console.log('removeQuestion', key);

			this.activeQuiz.questions.splice(key, 1);
		},

		addQuiz: function addQuiz(e) {
			var quiz = {
				name: this.newQuizName,
				uid: this.$store.state.user.uid,
				public: false,
				questions: []
			};

			var a = this.$store.state.db.ref('/quizzes').push(quiz);
			this.$store.commit('addQuiz', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ key: a.key }, quiz));


			this.openQuiz(a.key);

			this.newQuizName = '';
		},
		removeQuiz: function removeQuiz(key) {
			console.log('Remove', key);
			this.$store.commit('removeQuiz', key);
			this.activeQuizKey = null;
			this.activeQuiz = {};
		},
		updateQuiz: function updateQuiz() {

			if (!this.activeQuiz.variables) {
				this.activeQuiz.variables = [];
			}

			this.$store.commit('updateQuiz', { key: this.activeQuizKey, quiz: this.activeQuiz });
		},
		openQuiz: function openQuiz(key) {
			console.log('Should activate.', key);

			this.activeQuizKey = key;
			this.activeQuiz = this.quizzes[key];

			this.$set(this.activeQuiz, 'questions', this.activeQuiz.questions);
			this.$set(this.activeQuiz, 'variables', this.activeQuiz.variables);
		},
		closeQuiz: function closeQuiz() {
			this.activeQuizKey = null;
			this.activeQuiz = {};
		},
		download: function download() {
			console.log('Download');

			var content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.activeQuiz);

			console.log('content: ', content);

			var pom = document.createElement('a');
			pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
			pom.setAttribute('download', this.activeQuiz.name + '.json');

			if (document.createEvent) {
				var event = document.createEvent('MouseEvents');
				event.initEvent('click', true, true);
				pom.dispatchEvent(event);
			} else {
				pom.click();
			}
		}
	},

	computed: {
		quizzes: function quizzes() {
			return this.$store.state.quizzes;
		},
		saveEligible: function saveEligible() {
			return true;

			var q = this.activeQuiz;

			console.log('saveEligible', q);

			if (q.name == '') return false;

			if (!q.questions) return false;

			if (q.questions.length == 0) return false;

			console.log('Bis hier hin alles gut.');

			var hit = false;
			q.questions.forEach(function (v) {
				if (v.answer == '' || v.content == '' || v.answer == undefined || v.content == undefined) hit = true;
			});

			console.log('Hit: ', hit);

			return hit ? false : true;
		}
	},

	beforeCreate: function beforeCreate() {

		if (this.$store.state.user.isAnonymous) {
			this.$router.replace('/login');
		}

		this.$store.dispatch('loadQuizzes');
	},
	updated: function updated() {
		var _this = this;

		var el = document.getElementById('items');

		if (el) {
			var sortable = __WEBPACK_IMPORTED_MODULE_3_sortablejs___default.a.create(el, {
				handle: '.handle',
				onUpdate: function onUpdate(event) {

					_this.activeQuiz.questions.splice(event.newIndex + 1, 0, _this.activeQuiz.questions[event.oldIndex]);

					var adder = event.newIndex < event.oldIndex ? 1 : 0;
					console.log('remove vom index: ', event.oldIndex + adder);
					_this.activeQuiz.questions.splice(event.oldIndex + adder, 1);
				}
			});
		}

		__WEBPACK_IMPORTED_MODULE_2_autosize___default()(document.querySelectorAll("textarea"));
		__WEBPACK_IMPORTED_MODULE_2_autosize___default.a.update(document.querySelectorAll("textarea"));
	}
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_js__ = __webpack_require__(54);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			toUrl: __WEBPACK_IMPORTED_MODULE_0__helper_js__["b" /* toUrl */]
		};
	},
	metaInfo: function metaInfo() {
		return {
			meta: [{ name: 'description', content: this.quizCount + ' Online Tests mit denen du dein Wissen testen kannst.' }]
		};
	},
	beforeCreate: function beforeCreate() {
		this.$store.dispatch('loadPublicQuizzes');
	},


	computed: {
		quizCount: function quizCount() {
			return this.quizzes ? this.quizzes.length : 0;
		},
		quizzes: function quizzes() {

			return this.$store.state.publicQuizzes;
		}
	}

});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_autosize__);





var local = "production" == 'development';

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			quizKey: '-' + this.$route.params.key,
			name: this.$route.params.name,
			startTime: '',
			activeTab: -1,
			runInterval: null,
			local: local,
			transitionHeight: 0
		};
	},
	metaInfo: function metaInfo() {
		return {
			title: this.quiz ? this.quiz.name : '...',
			titleTemplate: '%s Online Quiz | Koonys Schule',
			meta: [{ name: 'description', content: this.quiz ? this.quiz.questions.length + ' online Aufgaben über ' + this.quiz.name + '. Dein Wissen direkt online testen mit Koonys Schule.' : 'Super Quiz.' }]
		};
	},

	methods: {

		beforeLeave: function beforeLeave(el) {

			this.transitionHeight = el.offsetHeight;
			el.parentNode.style.height = el.offsetHeight + 'px';
		},
		enter: function enter(el) {

			if (this.transitionHeight < el.offsetHeight) {
				el.parentNode.style.height = el.offsetHeight + 'px';
			}
		},
		afterLeave: function afterLeave(el) {
			document.getElementById('question-holder').style.height = "";
			this.transitionHeight = 0;
		},
		nextTab: function nextTab() {
			this.activeTab++;
		},
		lastTab: function lastTab() {
			this.activeTab--;
		},
		openTab: function openTab(tab) {
			this.activeTab = tab;
		},
		startQuiz: function startQuiz() {
			this.quiz.restart = true;

			clearInterval(this.runInterval);
			this.$store.dispatch('startQuiz', this.quiz.key);
		},
		deleteFame: function deleteFame(fameKey) {
			this.$store.dispatch('deleteFame', { fameKey: fameKey, quizKey: this.quiz.key });
		}
	},
	beforeCreate: function beforeCreate() {
		if (this.$route.params.key) {
			this.$store.dispatch('loadQuiz', this.$route.params.key);
		} else if (this.$route.params.name) {
			this.$store.dispatch('loadQuizByName', this.$route.params.name);
		} else {
			console.log('Quiz kann nicht geladen werden.');
		}
	},
	updated: function updated() {
		MathJax.Hub.Queue(["Typeset", MathJax.Hub]);

		if (this.quizSolved && !this.quiz.solved) {
			this.$store.commit('quizSolved');
		}
	},

	computed: {
		quiz: function quiz() {
			this.$store.state.user && this.$store.state.user.isAdmin && console.log('Compute Quiz.', this.$store.state.quiz);


			return this.$store.state.quiz;
		},
		questionsSolved: function questionsSolved() {
			return this.quiz.questions ? this.quiz.questions.reduce(function (p, v) {
				return p + v.answered;
			}, 0) : 0;
		},
		quizSolved: function quizSolved() {

			console.log('quizSolved', this.quizKey, this.quiz);
			return this.quiz && this.quiz.questions && this.questionsSolved == this.quiz.questions.length;
		},
		progress: function progress() {
			console.log('progress()', this.quizKey, this.quiz);
			return this.quiz && Math.round(this.questionsSolved / this.quiz.questions.length * 100);
		},
		hallOfFame: function hallOfFame() {
			return this.quiz.hallOfFame.sort(function (a, b) {
				return a.duration - b.duration;
			});
		},
		userRang: function userRang() {
			var _this = this;

			return this.hallOfFame.map(function (v, i) {
				return v.userid == _this.$store.state.user.uid ? { rang: i + 1, time: v.time } : { rang: -1 };
			}).filter(function (v) {
				return v.rang > -1;
			}).sort(function (a, b) {
				return b.time - a.time;
			});
		}
	},
	filters: {
		makeDurationPretty: function makeDurationPretty(time) {

			time = time / 1000;

			var seconds = Math.round(time % 60);
			seconds = seconds < 10 ? '0' + seconds : seconds;

			return Math.floor(time / 60) + ':' + seconds;
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.$store.commit('resetQuiz');
	}
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["ggT"] = ggT;
/* harmony export (immutable) */ __webpack_exports__["kgV"] = kgV;
/* harmony export (immutable) */ __webpack_exports__["kgV_wert"] = kgV_wert;
/* harmony export (immutable) */ __webpack_exports__["b"] = b;
/* harmony export (immutable) */ __webpack_exports__["bin"] = bin;
/* harmony export (immutable) */ __webpack_exports__["bv"] = bv;
/* harmony export (immutable) */ __webpack_exports__["kbv"] = kbv;
/* harmony export (immutable) */ __webpack_exports__["fac"] = fac;
function ggT(a, b) {
	if (a == 0 || b == 0) {
		console.log('Achtung beim ggT.', 'a', a, 'b', b);
		return 1;
	}

	var divisor = a < b ? a : b;
	var first = divisor == a ? b : a;

	var rest = 0;

	while (true) {
		rest = first % divisor;
		first = divisor;
		divisor = rest;
		if (rest == 0) return first;
	}
}

function kgV(a, b) {
	if (a == 0 || b == 0) {
		console.log('Achtung beim kgV.', 'a', a, 'b', b);
		return 0;
	}

	for (var i = a; i < 10000; i++) {
		if (i % a == 0 && i % b == 0) {
			return i;
		}
	}
}

function kgV_wert(a, b) {
	if (a == 0 || b == 0) {
		console.log('Achtung beim kgV.', 'a', a, 'b', b);
		return 0;
	}

	for (var i = a; i < 10000; i++) {
		if (i % a == 0 && i % b == 0) {
			return i / a;
		}
	}
}

function b($oben, $unten, $was) {
	var $return = 0;

	if ($was == 0) {
		$return = $oben / ggT($oben, $unten);
	} else if ($was == 1) {
		$return = $unten / ggT($oben, $unten);
	} else {
		$return = -1337;
	}

	if ($oben < 0 && $unten < 0) {
		$return = -1 * $return;
	} else if ($oben < 0 && $unten > 0) {} else if ($oben > 0 && $unten < 0) {
		$return = -1 * $return;
	}

	return $return;
}

function bin($n, $k) {
	return fac($n, 1) / (fac($k, 1) * fac($n - $k, 1));
}

function bv($n, $p, $k) {
	return bin($n, $k) * Math.pow($p, $k) * Math.pow(1 - $p, $n - $k);
}

function kbv($n, $p, $k) {
	var $ergebnis = 0;

	for (var $i = $k; $i >= 0; $i--) {
		$ergebnis = $ergebnis + bv($n, $p, $i);
	}

	return $ergebnis;
}

function fac($n, $end) {

	if ($n < $end) {
		if ($n == 0 && $end == 1) {
			return 1;
		} else {
			return -1;
		}
	} else if ($n == $end) {
		return $n;
	} else {
		return $n * fac($n - 1, $end);
	}
}

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_css__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_adsense__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Helper_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Helper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Helper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helper_js__ = __webpack_require__(54);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('adsense', __WEBPACK_IMPORTED_MODULE_8_vue_adsense__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('timer', __WEBPACK_IMPORTED_MODULE_9__components_Helper_vue__["timer"]);


__WEBPACK_IMPORTED_MODULE_10__helper_js__["a" /* questionTypes */].forEach(function (t) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('question-' + t.id, __webpack_require__(221)("./" + t.id + '/' + t.Id + '.vue'));
	__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('question-' + t.id + '-edit', __webpack_require__(220)("./" + t.id + '/' + t.Id + '.Edit.vue'));
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.nl2br = function (str) {
	return str ? str.replace(/\n/g, "<br />") : '';
};

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	store: __WEBPACK_IMPORTED_MODULE_7__store_js__["a" /* store */],
	router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fill", function() { return fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "evaluate", function() { return evaluate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_js__ = __webpack_require__(54);


var fill = function fill(varKey, varValue, question) {

	var r = {};
	r.type = question.type;

	r.answer = question.answer.replace(new RegExp(varKey, "g"), varValue);
	r.content = question.content.replace(new RegExp(varKey, "g"), varValue);

	r.alternatives = [];

	question.alternatives && question.alternatives.forEach(function (alternative, j, arrj) {

		r.alternatives.push({
			answer: alternative.answer.replace(new RegExp(varKey, "g"), varValue),
			message: alternative.message.replace(new RegExp(varKey, "g"), varValue)
		});
	});

	console.log('returne: ', r);

	return r;
};

var evaluate = function evaluate(question, n) {
	console.log('Evaluate ' + (n + 1) + '. Frage', question);

	var r = {};
	r.type = question.type;

	r.answer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["d" /* anna */])(question.answer);
	r.content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["c" /* video */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["d" /* anna */])(question.content, true));

	if (!r.alternatives) {
		r.alternatives = [];
	}

	question.alternatives && question.alternatives.forEach(function (alternative, i, arrj) {

		r.alternatives.push({
			answer: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["d" /* anna */])(alternative.answer),
			message: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["c" /* video */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["d" /* anna */])(alternative.message, true))
		});
	});

	r.tryings = [];

	return r;
};

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	fill: function fill(varKey, varValue, question) {
		return __webpack_require__(210)("./" + question.type + '/loader.js').fill(varKey, varValue, question);
	},
	evaluate: function evaluate(question, n) {
		return __webpack_require__(210)("./" + question.type + '/loader.js').evaluate(question, n);
	}
});

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return questionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return anna; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return video; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mathjs__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mathjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mathjs__);


var matheval = __WEBPACK_IMPORTED_MODULE_0_mathjs___default.a.eval;

var questionTypes = [];

questionTypes.push({
	id: 'one',
	Id: 'One',
	buttonText: 'Frage mit einer Lösung'
});



var mathHelper = __webpack_require__(232);

var ggT = mathHelper.ggT;
var kgV = mathHelper.kgV;
var kgV_wert = mathHelper.kgV_wert;
var b = mathHelper.b;
var fac = mathHelper.fac;
var bin = mathHelper.bin;
var bv = mathHelper.bv;
var kbv = mathHelper.kbv;

function escapeRegExp(str) {
	return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

function replaceMathHelper(str) {
	var ceilFinder = str.match(/(ceil|floor)\([^()]*\)/g);

	ceilFinder && ceilFinder.forEach(function (v) {
		var e = matheval(v);

		str = str.replace(new RegExp(escapeRegExp(v), "g"), e);
	});

	var findings = str.match(/(ggT|kgV|kgV_wert|b|fac|bin|kbv|bv)\(((?!\)|:an:|§).)*\)/g);
	findings && findings.forEach(function (v) {

		var e = eval(v);

		str = str.replace(new RegExp(escapeRegExp(v), "g"), e);
	});

	return str;
}

var toUrl = function toUrl(str) {
	return str.replace(/ /g, '-');
};

var anna = function anna(str, forShow) {

	var findings = void 0;

	str = replaceMathHelper(str);

	if (forShow) {
		findings = str.match(/\$(:an:|§)((?!:na:|§).)*(:na:|§)\$/g);


		findings && findings.forEach(function (v) {

			var toEval = v.charAt(0) == '§' ? v.substring(1, v.length - 1) : v.substring(4, v.length - 4);

			var leEval = matheval(toEval);

			leEval = ('' + leEval).replace(/\./g, '{{,}}');

			str = str.replace(v, leEval);
		});
	}

	findings = str.match(/(:an:|§)((?!:na:|§).)*(:na:|§)/g);


	findings && findings.forEach(function (v) {

		var toEval = v.charAt(0) == '§' ? v.substring(1, v.length - 1) : v.substring(4, v.length - 4);

		var leEval = matheval(toEval);

		if (forShow) leEval = ('' + leEval).replace(/\./g, ',');

		str = str.replace(v, leEval);
	});

	return str;
};

var videoString = '\n<div class="embed-responsive embed-responsive-16by9">\n<iframe class="embed-responsive-item" src="{{videourl}}" frameborder="0" allowfullscreen></iframe>\n</div>\n';

var video = function video(str) {
	if (!str) return str;

	var findings = str.match(/\[video:((?!\]).)*\]/g);

	findings && findings.forEach(function (found) {

		var replacer = videoString.replace('{{videourl}}', found.substring(7, found.length - 1));

		str = str.replace(found, replacer);
	});

	return str;
};

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(708),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(707),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1cf0902e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(287)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(712),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f224345",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(706),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ae77114",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(709),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(288)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(713),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(714),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 706:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.nl2br(_vm.question.content))
    }
  }), _vm._v(" "), (!_vm.question.answered) ? _c('div', [_c('b-input-group', {
    staticClass: "col-12 col-sm-10 offset-sm-2 col-md-8 offset-md-4 col-lg-6 offset-lg-6 mb-2"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Lösung..."
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submitAnswer()
      }
    },
    model: {
      value: (_vm.question.userAnswer),
      callback: function($$v) {
        _vm.question.userAnswer = $$v
      },
      expression: "question.userAnswer"
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    attrs: {
      "variant": 'success'
    },
    on: {
      "click": function($event) {
        _vm.submitAnswer()
      }
    }
  }, [_vm._v("lösen")])], 1)], 1), _vm._v(" "), _vm._l((_vm.question.tryings), function(tried, tey) {
    return _c('b-alert', {
      key: tey,
      attrs: {
        "variant": tried.type,
        "show": "",
        "dismissible": true
      }
    }, [_c('strong', [_vm._v(_vm._s(tried.answer))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.nl2br(tried.message))
      }
    })])
  })], 2) : _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "badge badge-info"
  }, [_vm._v(_vm._s(_vm.question.answer) + " "), _c('i', {
    staticClass: "fa fa-check fa-fw"
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ins', {
    staticClass: "adsbygoogle",
    style: (_vm.adStyle),
    attrs: {
      "data-ad-client": _vm.adClient,
      "data-ad-slot": _vm.adSlot,
      "data-ad-format": _vm.adFormat
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "editquizzes"
    }
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12 col-md-3"
  }, [_c('b-list-group', [(_vm.quizzes && _vm.quizzes.length == 0) ? _c('b-list-group-item', {
    staticClass: "py-3 text-info"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.quizzes), function(quiz, key) {
    return _c('a', {
      key: key,
      staticClass: "list-group-item list-group-item-action",
      class: {
        'active': _vm.activeQuizKey == key
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openQuiz(key)
        }
      }
    }, [(quiz.public) ? _c('i', {
      staticClass: "fa fa-globe fa-fw"
    }) : _vm._e(), _vm._v(" " + _vm._s(quiz.name) + "\n\t\t\t\t")])
  }), _vm._v(" "), _c('b-list-group-item', [_c('p', {
    staticClass: "w-100"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Titel..."
    },
    model: {
      value: (_vm.newQuizName),
      callback: function($$v) {
        _vm.newQuizName = $$v
      },
      expression: "newQuizName"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "text-center w-100"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.newQuizName === '',
      "variant": 'warning'
    },
    on: {
      "click": _vm.addQuiz
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Quiz hinzufügen")])], 1)])], 2)], 1), _vm._v(" "), (_vm.activeQuizKey !== null) ? _c('div', {
    staticClass: "col-12 col-md-9"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 py-2 text-right"
  }, [_c('b-form-checkbox', {
    attrs: {
      "true-value": true,
      "false-value": false
    },
    model: {
      value: (_vm.activeQuiz.public),
      callback: function($$v) {
        _vm.activeQuiz.public = $$v
      },
      expression: "activeQuiz.public"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.activeQuiz.public ? 'Öffentlich' : 'Nicht öffentlich') + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.preview
    }
  }, [_vm._v("Preview")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": 'success',
      "disabled": !_vm.saveEligible
    },
    on: {
      "click": _vm.updateQuiz
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": 'link',
      "size": 'sm',
      "title": "Löschen mit Doppelklick."
    },
    nativeOn: {
      "dblclick": function($event) {
        _vm.removeQuiz(_vm.activeQuizKey)
      }
    }
  }, [_vm._v("Löschen")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": 'link',
      "size": 'sm',
      "title": "Quiz schließen"
    },
    on: {
      "click": _vm.closeQuiz
    }
  }, [_vm._v("schließen")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": 'secondary',
      "size": 'sm',
      "title": "Quiz downloaden"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 py-2"
  }, [_c('b-input-group', {
    attrs: {
      "left": "Überschrift",
      "size": 'lg'
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.activeQuiz.name),
      callback: function($$v) {
        _vm.activeQuiz.name = $$v
      },
      expression: "activeQuiz.name"
    }
  })], 1), _vm._v(" "), _c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "textarea": true,
      "placeholder": "Beschreibung..."
    },
    model: {
      value: (_vm.activeQuiz.description),
      callback: function($$v) {
        _vm.activeQuiz.description = $$v
      },
      expression: "activeQuiz.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row my-3"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "list-group",
    attrs: {
      "id": "items"
    }
  }, _vm._l((_vm.activeQuiz.questions), function(question, key) {
    return _c('div', {
      key: question,
      staticClass: "list-group-item mb-2 border-0 px-0"
    }, [_c('div', {
      staticClass: "col-12 px-0"
    }, [_c('h6', [_c('i', {
      staticClass: "fa fa-arrows-alt fa-fw handle"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(key + 1) + ". Frage\n\t\t\t\t\t\t\t\t\t\t\t"), _c('b-button', {
      staticClass: "text-muted pull-right",
      attrs: {
        "variant": 'link',
        "size": 'sm'
      },
      nativeOn: {
        "dblclick": function($event) {
          _vm.removeQuestion(key)
        }
      }
    }, [_vm._v("entfernen")])], 1)]), _vm._v(" "), _c('question-' + question.type + '-edit', {
      tag: "div",
      staticClass: "col-12 px-0",
      attrs: {
        "question": question,
        "questionKey": key
      },
      on: {
        "remove": _vm.removeQuestion
      }
    })])
  })), _vm._v(" "), _c('div', _vm._l((_vm.questionTypes), function(type, key) {
    return _c('b-button', {
      key: key,
      on: {
        "click": function($event) {
          _vm.addQuestion(type.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-fw"
    }), _vm._v(" " + _vm._s(type.buttonText))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.activeQuiz.variables && _vm.activeQuiz.variables.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 ml-1"
  }, [_vm._v("von")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 ml-1"
  }, [_vm._v("bis")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeQuiz.variables), function(variable, variableKey) {
    return _c('div', {
      key: variableKey,
      staticClass: "row mb-2"
    }, [_c('b-form-input', {
      staticClass: "col-3",
      attrs: {
        "type": 'text'
      },
      model: {
        value: (variable.name),
        callback: function($$v) {
          variable.name = $$v
        },
        expression: "variable.name"
      }
    }), _vm._v(" "), _c('b-form-input', {
      staticClass: "col-3 ml-1",
      attrs: {
        "type": 'number'
      },
      model: {
        value: (variable.from),
        callback: function($$v) {
          variable.from = $$v
        },
        expression: "variable.from"
      }
    }), _vm._v(" "), _c('b-form-input', {
      staticClass: "col-3 ml-1",
      attrs: {
        "type": 'number'
      },
      model: {
        value: (variable.to),
        callback: function($$v) {
          variable.to = $$v
        },
        expression: "variable.to"
      }
    }), _vm._v(" "), _c('b-button', {
      staticClass: "col-2",
      attrs: {
        "variant": 'link'
      },
      on: {
        "click": function($event) {
          _vm.removeVariable(variableKey)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times fa-fw"
    })])], 1)
  }), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mt-2",
    on: {
      "click": _vm.addVariable
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-fw"
  }), _vm._v(" Variable")])], 2)])])])]) : _c('div', {
    staticClass: "col-12 col-md-9"
  }, [_c('h3', [_vm._v("So geht's")]), _vm._v(" "), _c('dl', {
    staticClass: "mt-5"
  }, [_c('dt', [_vm._v("Videos")]), _vm._v(" "), _c('dd', [_vm._v("\n\t\t\t\t\tUm Videos einzubinden schreibt man:\n\t\t\t\t\t"), _c('code', [_vm._v("[video:http://www.youtube.com/embed/"), _c('strong', [_vm._v("DLzxrzFCyOs")]), _vm._v("?rel=0]")])])]), _vm._v(" "), _c('dl', {
    staticClass: "mt-5"
  }, [_c('dt', [_vm._v(":Variablen:")]), _vm._v(" "), _c('dd', [_vm._v("Den Namen der Variablen einfach in \":\" setzen."), _c('br'), _vm._v(" "), _c('code', [_vm._v(":a: + :b:")]), _vm._v(" wird zu "), _c('code', [_vm._v("3 + 4")]), _vm._v(", wenn a = 3 und b = 4.")])]), _vm._v(" "), _c('dl', {
    staticClass: "mt-5"
  }, [_c('dt', [_vm._v("$Latex$")]), _vm._v(" "), _c('dd', [_vm._v("\n\t\t\t\t\tLatex ist via "), _c('a', {
    attrs: {
      "href": "https://www.mathjax.org/",
      "target": "_blank"
    }
  }, [_vm._v("MathJax")]), _vm._v(" möglich. Also einfach in Dollarzeichen setzen."), _c('br'), _vm._v(" "), _c('code', [_vm._v("$ :a: \\over :b:$")]), _vm._v(" ergibt einen schönen Bruch."), _c('br'), _vm._v("\n\t\t\t\t\tMit zwei Dollarzeichen wird die Mathematik in einer Zeile mittig angezeigt.\n\t\t\t\t")])]), _vm._v(" "), _c('dl', {
    staticClass: "mt-5"
  }, [_c('dt', [_vm._v("§Berechnungen§")]), _vm._v(" "), _c('dd', [_vm._v("\n\t\t\t\t\tMöchte man etwas berechnen lassen, stellt man den mathematischen Ausdruck in Paragrafen."), _c('br'), _vm._v(" "), _c('code', [_vm._v("§3+4§")]), _vm._v(" ergibt "), _c('code', [_vm._v("7")]), _c('br'), _vm._v("\n\t\t\t\t\tDies ist auch in Verbindung mit Variablen möglich."), _c('br'), _vm._v(" "), _c('code', [_vm._v("§ :a:/:b:§")]), _vm._v(" ergibt "), _c('code', [_vm._v("0,75")]), _vm._v(".\n\t\t\t\t")])]), _vm._v(" "), _c('dl', {
    staticClass: "mt-5"
  }, [_c('dt', [_vm._v("Komplexere Berechnungen")]), _vm._v(" "), _c('dd', [_vm._v("\n\t\t\t\t\tDie gängisten Funktionen sind via "), _c('a', {
    attrs: {
      "href": "http://mathjs.org/",
      "target": "_blank"
    }
  }, [_vm._v("math.js")]), _vm._v(" in Berechnungen verfügbar."), _c('br'), _vm._v(" "), _c('code', [_vm._v("§ round( sin( 40 deg), 2)§")]), _vm._v(" ergibt "), _c('code', [_vm._v("0,64")]), _vm._v(".\n\t\t\t\t")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "",
      "variant": "faded"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/favicon.ico",
      "width": "30",
      "height": "30",
      "classs": "d-inline-block align-top",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Koonys Quizzes "), _c('span', {
    attrs: {
      "id": "beta"
    }
  }, [_vm._v("Beta")])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Startseite")])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [(_vm.user.isAnonymous) ? _c('b-nav-item', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]) : _c('b-nav-item-dropdown', {
    staticClass: "img-profile",
    attrs: {
      "right": true,
      "caret": false
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('img', {
    staticClass: "hidden-sm-down",
    attrs: {
      "src": _vm.user.photoURL,
      "title": _vm.user.displayName
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-md-up"
  }, [_vm._v("Account")])]), _vm._v(" "), _c('b-dropdown-header', [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/user/quizzes"
    }
  }, [_c('i', {
    staticClass: "fa fa-user fa-fw"
  }), _vm._v(" Deine Quizzes")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-fw"
  }), _vm._v(" Signout")])], 2)], 1)], 1)], 1), _vm._v(" "), (_vm.user.uid !== null) ? _c('router-view') : _c('div'), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "footer"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "link",
      "size": "sm",
      "onclick": "_urq.push(['Feedback_Open'])"
    }
  }, [_vm._v("Feedback")])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('hr')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('small', [_c('a', {
    staticClass: "text-muted",
    attrs: {
      "href": "http://www.koonys.de",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-copyright fa-fw"
  }), _vm._v(" Koonys Schule")])])])
}]}

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    attrs: {
      "textarea": true
    },
    model: {
      value: (_vm.question.content),
      callback: function($$v) {
        _vm.question.content = $$v
      },
      expression: "question.content"
    }
  }), _vm._v(" "), _c('b-input-group', {
    staticClass: "mt-2",
    attrs: {
      "left": "Antwort"
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.question.answer),
      callback: function($$v) {
        _vm.question.answer = $$v
      },
      expression: "question.answer"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.question.alternatives), function(alternative, altKey) {
    return _c('div', {
      key: altKey,
      staticClass: "mt-2 ml-5"
    }, [_c('b-button', {
      staticClass: "pull-right",
      attrs: {
        "size": 'sm',
        "variant": 'link'
      },
      on: {
        "click": function($event) {
          _vm.removeAlternative(_vm.questionKey, altKey)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times text-muted"
    })]), _vm._v(" "), _c('b-input-group', {
      staticClass: "mb-1",
      attrs: {
        "left": (altKey + 1) + '. Alternative',
        "size": 'sm'
      }
    }, [_c('b-form-input', {
      model: {
        value: (alternative.answer),
        callback: function($$v) {
          alternative.answer = $$v
        },
        expression: "alternative.answer"
      }
    })], 1), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "textarea": true,
        "placeholder": "Message.."
      },
      model: {
        value: (alternative.message),
        callback: function($$v) {
          alternative.message = $$v
        },
        expression: "alternative.message"
      }
    })], 1)
  }), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mt-2",
    attrs: {
      "variant": 'link',
      "size": 'sm'
    },
    on: {
      "click": function($event) {
        _vm.addAlternative()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-fw"
  }), _vm._v(" Alternative")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login py-5"
  }, [_c('div', {
    attrs: {
      "id": "firebaseui-auth-container"
    }
  }), _vm._v(" "), (_vm.logged) ? _c('div', {
    staticClass: "alert alert-success col-6 offset-3 my-5"
  }, [_vm._v("\n    Du bist eingeloggt.\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (Object.keys(_vm.quizzes).length) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.quizzes), function(quiz, key) {
    return _c('div', {
      key: quiz.key,
      staticClass: "col-12 col-sm-6 col-md-4 col-lg-4 mt-3"
    }, [_c('b-card', {
      attrs: {
        "title": quiz.name,
        "sub-title": quiz.questions.length + ' Fragen'
      }
    }, [_c('div', {
      staticClass: "text-right"
    }, [_c('b-button', {
      attrs: {
        "to": {
          name: 'QuizByName',
          params: {
            name: _vm.toUrl(quiz.name)
          }
        }
      }
    }, [_vm._v("Quiz starten")])], 1)])], 1)
  }))]) : _c('div', {
    staticClass: "col-12 mt-5"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-fw text-muted"
  }), _vm._v(" Quizzes werden geladen.\n\t\t")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 mt-4"
  }, [_c('h1', [_vm._v("Wähle ein Quiz")]), _vm._v(" "), _c('p', [_vm._v("Durch Fragen besser in Mathe.")])])
}]}

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mb-5"
  }, [(_vm.quiz === null) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : (_vm.quiz.failed) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 offset-md-3 mt-5 text-center"
  }, [_c('b-alert', {
    attrs: {
      "variant": 'danger',
      "show": ""
    }
  }, [_vm._v("Laden des Quizzes fehlgeschlagen.")])], 1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mt-3"
  }, [_c('h4', {
    staticClass: "pt-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.quiz.name))]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline nav-pills text-center",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: [_vm.activeTab == -1 ? 'active' : ''],
    attrs: {
      "href": "#",
      "id": "startnav"
    },
    on: {
      "click": function($event) {
        _vm.openTab(-1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tStart\n\t\t\t\t\t")])]), _vm._v(" "), _vm._l((_vm.quiz.questions), function(question, key) {
    return _c('li', {
      key: key + 'nav',
      staticClass: "list-inline-item",
      attrs: {
        "id": key + 'nav'
      }
    }, [_c('a', {
      staticClass: "nav-link",
      class: {
        'active': _vm.activeTab == key
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openTab(key)
        }
      }
    }, [(_vm.quiz.questions.length < 10) ? _c('span', [_vm._v(_vm._s((key + 1) + '. Frage'))]) : _c('span', [_vm._v(_vm._s(key + 1))]), _vm._v(" "), (question.answered) ? _c('i', {
      staticClass: "fa fa-check fa-fw"
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.quizSolved) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      'active': _vm.activeTab == _vm.quiz.questions.length
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.openTab(_vm.quiz.questions.length)
      }
    }
  }, [_vm._v("Rangliste")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 offset-md-3 mt-3 mb-4"
  }, [_c('b-progress', {
    staticStyle: {
      "height": "5px"
    },
    attrs: {
      "value": _vm.progress,
      "variant": 'success'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-8 offset-lg-2",
    attrs: {
      "id": "question-holder"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "before-leave": _vm.beforeLeave,
      "after-leave": _vm.afterLeave,
      "enter": _vm.enter
    }
  }, [(_vm.activeTab == -1) ? _c('div', {
    key: 'starttab',
    staticClass: "tab-pane active",
    attrs: {
      "id": "starttab"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.nl2br(_vm.quiz.description))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [(!_vm.local) ? _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8001728079841345",
      "ad-slot": "8970086511",
      "ad-style": "display: block",
      "ad-format": "auto"
    }
  }) : _c('p', {
    staticClass: "text-center text-muted"
  }, [_vm._v("Werbung")])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [(_vm.progress < 100) ? _c('timer', {
    attrs: {
      "time": _vm.quiz.startTime
    }
  }) : _c('div', [_c('i', {
    staticClass: "fa fa-clock-o fa-fw text-info"
  }), _vm._v(" " + _vm._s(_vm._f("makeDurationPretty")(_vm.quiz.endTime - _vm.quiz.startTime)))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o fa-fw"
  }), _vm._v(" " + _vm._s(_vm.progress) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "w-100 hidden-sm-up"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [(_vm.progress < 100) ? _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'link'
    },
    on: {
      "click": _vm.startQuiz
    }
  }, [(_vm.quiz.restart) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner fa-fw"
  }) : _vm._e(), _vm._v(" Neustart")]) : _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'warning'
    },
    on: {
      "click": _vm.startQuiz
    }
  }, [(_vm.quiz.restart) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner fa-fw"
  }) : _vm._e(), _vm._v(" erneut starten")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.quizSolved) ? _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'primary'
    },
    on: {
      "click": function($event) {
        _vm.openTab(_vm.quiz.questions.length)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-fw"
  }), _vm._v(" Rangliste")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": 'sm',
      "variant": _vm.quizSolved ? 'secondary' : 'success'
    },
    on: {
      "click": _vm.nextTab
    }
  }, [_vm._v("1. Frage "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])], 1)])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.quiz.questions), function(question, key) {
    return (_vm.activeTab == key) ? _c('div', {
      key: key + 'tab',
      staticClass: "tab-pane active",
      attrs: {
        "id": key + 'tab'
      }
    }, [_c('question-' + question.type, {
      tag: "div",
      attrs: {
        "question": question,
        "questionKey": key
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mt-3 row"
    }, [_c('div', {
      staticClass: "col"
    }, [(_vm.activeTab > -1) ? _c('b-button', {
      attrs: {
        "size": 'sm'
      },
      on: {
        "click": _vm.lastTab
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-left"
    }), _vm._v(" " + _vm._s(key == 0 ? 'Start' : key + '. Frage'))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col text-center"
    }, [(_vm.quizSolved) ? _c('b-button', {
      attrs: {
        "size": 'sm',
        "variant": 'primary'
      },
      on: {
        "click": function($event) {
          _vm.openTab(_vm.quiz.questions.length)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-line-chart fa-fw"
    }), _vm._v(" Rangliste")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [(_vm.activeTab < _vm.quiz.questions.length - 1) ? _c('b-button', {
      staticClass: "pull-right",
      attrs: {
        "size": 'sm',
        "variant": question.answered ? 'success' : 'secondary'
      },
      on: {
        "click": _vm.nextTab
      }
    }, [_vm._v(_vm._s(key + 2) + ". Frage "), _c('i', {
      staticClass: "fa fa-arrow-right"
    })]) : _vm._e()], 1)])]) : _vm._e()
  }), _vm._v(" "), (_vm.quizSolved && _vm.activeTab == _vm.quiz.questions.length) ? _c('div', {
    staticClass: "tab-pane active"
  }, [_c('b-card', [_c('div', [_c('b-button', {
    attrs: {
      "size": 'sm'
    },
    on: {
      "click": _vm.lastTab
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-fw"
  }), _vm._v(" " + _vm._s(_vm.quiz.questions.length) + ". Frage")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": 'sm'
    },
    on: {
      "click": function($event) {
        _vm.openTab(-1)
      }
    }
  }, [_vm._v("Start")])], 1), _vm._v(" "), (_vm.userRang.length > 0) ? _c('h5', {
    staticClass: "text-center mt-5 mt-sm-0"
  }, [_vm._v("Du hast den " + _vm._s(_vm.userRang[0].rang) + ". Platz erreicht.")]) : _c('h6', {
    staticClass: "text-center text-muted mt-5 mt-sm-0"
  }, [_vm._v("Keine Ranglisteneinträge von dir vorhanden.")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [(!_vm.local) ? _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8001728079841345",
      "ad-slot": "9735469318",
      "ad-style": "display: block",
      "ad-format": "auto"
    }
  }) : _c('p', {
    staticClass: "text-center text-muted"
  }, [_vm._v("Werbung")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block mt-4"
  }, [_c('transition-group', {
    staticClass: "list-unstyled",
    attrs: {
      "name": "hallOfFame",
      "tag": "ul"
    }
  }, _vm._l((_vm.hallOfFame), function(fame, key) {
    return _c('dl', {
      key: fame,
      staticClass: "row"
    }, [_c('dt', {
      staticClass: "col-sm-3"
    }, [_c('span', {
      staticClass: "badge badge-pill badge-info"
    }, [_vm._v(_vm._s(key + 1) + ".")]), _vm._v("  " + _vm._s(_vm._f("makeDurationPretty")(fame.duration))), _c('i', {
      staticClass: "fa fa-clock-o fa-fw"
    })]), _vm._v(" "), (fame.userid == _vm.$store.state.user.uid) ? _c('dd', {
      staticClass: "col-sm-9"
    }, [_c('mark', {
      on: {
        "click": function($event) {
          _vm.deleteFame(fame.key)
        }
      }
    }, [_vm._v(_vm._s(fame.username ? fame.username : 'Anonym'))])]) : (fame.username) ? _c('dd', {
      staticClass: "col-sm-9"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(fame.username) + "\n\t\t\t\t\t\t\t\t\t")]) : _c('dd', {
      staticClass: "col-sm-9"
    }, [_c('span', {
      on: {
        "click": function($event) {
          _vm.deleteFame(fame.key)
        }
      }
    }, [_vm._v("Anonym")])])])
  }))], 1)])], 1) : _vm._e()], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-3x fa-fw text-muted mt-5"
  })])
}]}

/***/ })

},[233]);


// WEBPACK FOOTER //
// static/js/app.e28ff349bd8fac04291b.js